import { useState, useMemo, createContext, useContext } from 'react';
import { useKeyboardNavigation } from './hooks/useKeyboardNavigation.js';
import { jsx } from 'react/jsx-runtime';

var Context = /*#__PURE__*/createContext({});
var useCalendar = function useCalendar() {
  return useContext(Context);
};
function Provider(props) {
  var children = props.children,
    onChange = props.onChange,
    _props$value = props.value,
    value = _props$value === void 0 ? new Date() : _props$value,
    locale = props.locale,
    timeZone = props.timeZone,
    _props$weekStartsOn = props.weekStartsOn,
    weekStartsOn = _props$weekStartsOn === void 0 ? 0 : _props$weekStartsOn,
    min = props.min,
    max = props.max,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown;
  var _useState = useState(value),
    focusedDate = _useState[0],
    setFocusedDate = _useState[1];
  var _useState2 = useState(focusedDate),
    focusedYear = _useState2[0],
    setFocusedYear = _useState2[1];
  var _useState3 = useState(false),
    yearPickerVisible = _useState3[0],
    setYearPickerVisible = _useState3[1];
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var toggleYearPicker = function toggleYearPicker() {
    return setYearPickerVisible(function (prevState) {
      return !prevState;
    });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var hideYearPicker = function hideYearPicker() {
    return setYearPickerVisible(false);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var showYearPicker = function showYearPicker() {
    return setYearPickerVisible(true);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var selectYear = function selectYear(date) {
    setFocusedDate(date);
    setFocusedYear(date);
    hideYearPicker();
  };
  var _useKeyboardNavigatio = useKeyboardNavigation({
      onKeyDown: onKeyDown,
      focusedDate: focusedDate,
      setFocusedDate: setFocusedDate,
      focusedYear: focusedYear,
      setFocusedYear: setFocusedYear,
      yearPickerVisible: yearPickerVisible
    }),
    handleKeyDown = _useKeyboardNavigatio.handleKeyDown;
  var context = useMemo(function () {
    return {
      focusedDate: focusedDate,
      setFocusedDate: setFocusedDate,
      value: value,
      onChange: onChange,
      locale: locale,
      timeZone: timeZone,
      weekStartsOn: weekStartsOn,
      min: min,
      max: max,
      onFocus: onFocus,
      onBlur: onBlur,
      onKeyDown: handleKeyDown,
      yearPickerVisible: yearPickerVisible,
      toggleYearPicker: toggleYearPicker,
      hideYearPicker: hideYearPicker,
      showYearPicker: showYearPicker,
      selectYear: selectYear,
      focusedYear: focusedYear,
      setFocusedYear: setFocusedYear
    };
  }, [focusedDate, setFocusedDate, value, onChange, locale, timeZone, weekStartsOn, min, max, onFocus, onBlur, handleKeyDown, yearPickerVisible, toggleYearPicker, hideYearPicker, showYearPicker, selectYear, focusedYear, setFocusedYear]);
  return /*#__PURE__*/jsx(Context.Provider, {
    value: context,
    children: children
  });
}

export { Provider, useCalendar };
